const weightUnitFormatter = new Intl.NumberFormat("it-IT", {
  style: "unit",
  unit: "kilogram",
  unitDisplay: "short",
  minimumIntegerDigits: 1,
  maximumFractionDigits: 2,
  minimumFractionDigits: 1
});

export function formatWeight(value: number | undefined | null): string {
  if (value === undefined || value === null) {
    return "";
  }

  return weightUnitFormatter.format(value);
}
